module.exports = __webpack_public_path__ + "img/down-row-in.1dfeafa0.svg";